import React from "react";

const withoutDriverRegexp = /<withoutDriver>(.+)<\/withoutDriver>/gm;

const WithoutDriver = ({ title }) => {
    const matchData = [];
    let match;
    while ((match = withoutDriverRegexp.exec(title)) !== null) {
        matchData.push(match);
    }
    if (matchData.length === 0) {
        return title;
    }

    return matchData.reduce((acc, item, index) => {
        const prevItemEndedAt = index === 0 ? 0 : matchData[index - 1].index + matchData[index - 1][0].length;
        if (prevItemEndedAt < item.index) {
            acc.push(<span>{title.substring(prevItemEndedAt, item.index)}</span>);
        }

        acc.push(<span className="font-weight-bold text-danger">{item[1]}</span>);

        if (index === matchData.length - 1 && title.length > item.index + item[0].length) {
            acc.push(<span>{title.substring(item.index + item[0].length)}</span>);
        }
        return acc;
    }, []);
};

export default WithoutDriver;
